<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Búsqueda de pre ordenes</p>
    </header>
    <section class="modal-card-body">
      <b-table :data="data"
               ref="orders_table"
               @keyup.enter.native="onKeyPressEnter"
               @keyup.37.native="onKeyPressLeft"
               @keyup.39.native="onKeyPressRight"
               :selected.sync="selected"
               @dblclick="onSelectOrder"
               focusable>
        <b-table-column label="PreOrden" width="40" numeric v-slot="props">
          {{ props.row.id }}
        </b-table-column>
        <b-table-column label="Fecha" v-slot="props">
          {{ props.row.date | date('LL') }}
        </b-table-column>
        <b-table-column label="Paciente" v-slot="props">
          {{ props.row.patient.code }}
        </b-table-column>
        <b-table-column label="Fecha de Nacimiento" v-slot="props">
          {{ props.row.patient.birthday }}
        </b-table-column>
      </b-table>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button"
              @click="$parent.close()">
        Cerrar
      </button>
      <button class="button is-primary" type="button" @click="onSelectOrder" :disabled="!selected">
        Seleccionar
      </button>
    </footer>
  </div>
</template>

<script>
import {mapState} from 'vuex';
export default {
  name: "ModalSelectPreOrder",
  props: {
    data: Array
  },
  data() {
    return {
      selected: null,
      currentPage: 1,
      perPage: 10
    }
  },
  computed: {
    ...mapState({
      branchOffices: state => state.main.branchOffices
    }),
  },
  mounted() {
    if (this.data.length) {
      this.selected = this.data[0];
      setTimeout(() => {
        this.$refs.orders_table.focus();
      }, 100);
    }
  },
  methods: {
    getNameBranchOffice(id) {
      return this.branchOffices.find(el => el.id = id).name
    },
    onSelectOrder() {
      this.$emit('selectOrder', this.selected);
      this.$parent.close();
    },
    onKeyPressEnter() {
      this.getNameBranchOffice(this.selected);
    },
    onKeyPressLeft() {
      if (this.data.length > this.perPage) {
        if (this.currentPage > 1) {
          this.currentPage -= 1;
        }
      }
    },
    onKeyPressRight() {
      if (this.data.length > this.perPage) {
        let pages = Math.ceil(this.data.length / this.perPage);
        if (this.currentPage < pages) {
          this.currentPage += 1;
        }
      }
    },
  }
}
</script>

<style scoped>

</style>
